<template>
    <div class="">
        <info-modal
            ref="infoModal"
            :msg="infoMsg"
        />
        <liff-error-modal
            ref="errorModal"
            @ok-submit="closeWindow"
            :msg="errorMsg"
        />

        <div class="bg-liff">
            <div class="header-text">
                <div>
                    {{$vuetify.lang.t('$vuetify.approvalInquiry.approvalInquiry')}}
                </div>
                <span class="lang mr-3">
                    <change-lang />
                </span>
            </div>
            <div
                class="data-container">
                <v-row>
                    <v-col cols="6">
                        <span class="label-tag">
                            {{$vuetify.lang.t('$vuetify.approvalInquiry.typeInquiry')}}
                        </span>
                        <v-select
                            v-model="search.laoType"
                            :items="typeList"
                            solo
                            height="40px"
                            item-text="text"
                            item-value="value"
                            @change="getInquiryPagination()">
                        </v-select>
                    </v-col>
                    <v-col cols="6">
                        <div class="ml-day-inquiry">
                            <span class="label-tag">
                                {{$vuetify.lang.t('$vuetify.approvalInquiry.date')}}
                            </span>
                            <v-menu
                                ref="inquiryDayMenu"
                                v-model="datePickerShow"
                                :close-on-content-click="false"
                                transition="scale-transition"
                                offset-y
                                min-width="234px">
                                <template v-slot:activator="{ on }">
                                    <v-text-field
                                        prepend-inner-icon="event"
                                        @click:prepend-inner="datePickerShow = true"
                                        v-model="dateFormatted"
                                        readonly
                                        v-on="on"
                                        solo
                                        height="40px"
                                        background-color="#ffffff"
                                    ></v-text-field>
                                </template>
                                <v-date-picker
                                    :locale="localeLang"
                                    ref="inquireDatePicker"
                                    v-model="search.inquireDate"
                                    @change="saveInquireDate"
                                ></v-date-picker>
                            </v-menu>
                        </div>
                    </v-col>
                </v-row>
                <div
                    class="no-data"
                    v-if="totalData === 0">
                    {{ inquiryMessage }}{{ $util.formatDate(search.inquireDate) }}
                </div>
                <div v-else>
                    <v-card>
                        <v-data-table
                            :footer-props="{
                                'items-per-page-options': [10, 20, 30, 50, 100]
                            }"
                            @page-count="pageCount = $event"
                            :page.sync="page"
                            :headers="headers"
                            :options.sync="options"
                            :server-items-length="totalData"
                            :items="laos"
                            :loading="loading">
                            <template v-slot:[`item.action`]="{ item }">
                                <div class="action" ref="statusContainer">
                                    <div
                                        :class="choiceClass('APV')"
                                        @click="changeStatus(item, 'APV')">
                                        {{$vuetify.lang.t('$vuetify.approvalInquiry.approve')}}
                                    </div>
                                    <div
                                        :class="choiceClass('REJ')"
                                        @click="changeStatus(item, 'REJ')">
                                        {{$vuetify.lang.t('$vuetify.approvalInquiry.reject')}}
                                    </div>
                                </div>
                            </template>
                        </v-data-table>
                    </v-card>
                    <div
                        class="pt-2 paginator-box">
                        <div>
                            <v-pagination v-model="page" :length="pageCount"></v-pagination>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import InfoModal from '@/components/modal/InfoModal'
import ChangeLang from '@/components/liff/ChangeLang'
import LiffErrorModal from '@/components/modal/LiffErrorModal'
import axios from 'axios'
export default {
    name: 'ApprovalInquiry',
    components: {
        InfoModal,
        ChangeLang,
        LiffErrorModal
    },

    data () {
        return {
            infoMsg: null,
            datePickerShow: false,
            dateFormatted: this.$util.formatDate(this.$util.getCurrentDate()),
            search: {
                lineId: '',
                laoType: null,
                inquireDate: this.$util.getCurrentDate()
            },
            laos: [],
            pageCount: 1,
            page: 1,
            totalData: 0,
            options: {},
            loading: false,
            laoTypes: [],
            errorMsg: ''
        }
    },

    computed: {
        localeLang () {
            return this.$vuetify.lang.current
        },
        headers () {
            return [
                { text: this.$vuetify.lang.t('$vuetify.approvalInquiry.employeeNo'), value: 'employee__employee_no', width: '20%' },
                { text: this.$vuetify.lang.t('$vuetify.approvalInquiry.name'), value: 'employee__fullname', width: '40%' },
                { text: this.$vuetify.lang.t('$vuetify.approvalInquiry.date'), value: 'date', width: '20%', sortable: false },
                { text: '', value: 'action', width: '20%', sortable: false }
            ]
        },
        typeList () {
            const type = this.laoTypes
            type.unshift({
                text: this.$vuetify.lang.t('$vuetify.approvalInquiry.allType'),
                value: null
            })
            return type
        },
        inquiryMessage () {
            let textType = this.$vuetify.lang.t('$vuetify.approvalInquiry.allTypeMessage')
            if (this.search.laoType === 'PSL') {
                textType = this.$vuetify.lang.t('$vuetify.approvalInquiry.personalLeave')
            } else if (this.search.laoType === 'SKL') {
                textType = this.$vuetify.lang.t('$vuetify.approvalInquiry.sickLeave')
            } else if (this.search.laoType === 'ONS') {
                textType = this.$vuetify.lang.t('$vuetify.approvalInquiry.onSite')
            }
            return this.$vuetify.lang.t('$vuetify.approvalInquiry.inquiryMessageType').replace('$type', textType)
        }
    },

    methods: {
        closeWindow () {
            this.$liff.closeWindow()
        },

        errorAlert (message) {
            this.$store.dispatch('setLoading', false)
            this.$refs.errorModal.dialog = true
            this.errorMsg = message
        },

        choiceClass (statusChoice) {
            const style = 'choice'
            if (this.status === statusChoice) {
                return `${style} active`
            }
            return style
        },

        async getInquiryPagination () {
            this.loading = true
            const { sortBy, sortDesc, page, itemsPerPage } = this.options

            let url = `${process.env.VUE_APP_BACKEND}/inquirys-for-line?lineId=${this.search.lineId}`
            if (page) {
                url += `&page=${page}`
            }
            if (itemsPerPage) {
                url += `&itemsPerPage=${itemsPerPage}`
            }
            if (sortBy && sortBy[0]) {
                url += `&sortBy=${sortBy[0]}`
            }

            if (sortDesc && sortDesc[0]) {
                url += `&sortDesc=${sortDesc[0]}`
            }

            if (this.search.laoType) {
                url += `&laoType=${this.search.laoType}`
            }

            if (this.search.inquireDate) {
                url += `&inquireDate=${this.search.inquireDate}`
            }
            const res = await axios.get(url)
            if (res && res.data && res.data.status === 'ok') {
                this.laos = res.data.data
                this.totalData = res.data.total
            }
            this.loading = false
        },

        async getLaoType () {
            const res = await axios.get(`${process.env.VUE_APP_BACKEND}/leave-or-onsite/type`, {
                headers: {
                    'Accept-Language': this.$vuetify.lang.current
                }
            })
            if (res && res.data && res.data.status === 'ok') {
                this.laoTypes = res.data.data
            }
        },

        async saveInquireDate (date) {
            this.$refs.inquiryDayMenu.save(date)
            this.dateFormatted = this.$util.formatDate(date)
            await this.getInquiryPagination()
        },

        async changeStatus (lao, status) {
            this.$store.dispatch('setLoading', true)
            const res = await axios.put(
                `${process.env.VUE_APP_BACKEND}/approve-reject-leave/${lao.id}`,
                {
                    lineId: this.search.lineId,
                    status: status
                }
            )
            if (res && res.data && res.data.status === 'ok') {
                this.$store.dispatch('setLoading', false)
                this.infoMsg = this.$vuetify.lang.t('$vuetify.approvalInquiry.msgSuccess')
                this.$refs.infoModal.dialog = true
            } else {
                this.errorAlert(res.data.msg)
            }

            await this.getInquiryPagination()
        }
    },

    async mounted () {
        this.$store.dispatch('setLoading', true)
        try {
            this.search.lineId = await this.$util.getLineIdForLiff(process.env.VUE_APP_LINE_APPROVAL_INQUIRY_LIFF)
            await this.getLaoType()
            await this.getInquiryPagination()
        } catch (error) {
            this.errorAlert(this.$vuetify.lang.t('$vuetify.approvalInquiry.cannotGetLineId'))
        }
        this.$store.dispatch('setLoading', false)
    },

    watch: {
        options: {
            async handler () {
                if (this.search.lineId) {
                    await this.getInquiryPagination()
                }
            }
        },
        '$vuetify.lang.current': {
            handler: async function (after, before) {
                if (this.search.lineId) {
                    await this.getInquiryPagination()
                }
                await this.getLaoType()
            },
            deep: true
        }
    }
}
</script>

<style lang="scss" scoped>

.bg-liff {
    height: 100vh;
    background-color: #2E2929;
    color: #ffffff;

    .header-text {
        font-family: LexendDeca;
        font-size: 20px;
        padding: 1rem;
        height: 10%;
        min-height: 45px;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .data-container {
        background: #ffffff;
        border-top-right-radius: 30px;
        border-top-left-radius: 30px;
        color: #6c6c6c;
        padding: 2rem;
        font-size: 14px;
        font-weight: normal;
        overflow: scroll;
        height: 90%;
    }
}

@media screen and (orientation: landscape) {
    .bg-liff {
        display: flex;
        flex-direction: column;
        align-items: center;

        .data-container {
            min-width: 350px;
        }
    }
}

.lang {
    display: flex;
    justify-content: center;
    flex-direction: column;
    font-size: 18px;
    &-th{
        font-family: Prompt;
    }
    &-en{
        font-family: LexendDeca;
    }
}

.text-underline {
    text-decoration: underline;
    color: #d76436;
}

.action {
    display: inline-flex;
    padding-bottom: 20px;

    .disable {
        pointer-events: none;
        cursor: not-allowed;
    }

    .choice {
        font-size: 14px;
        line-height: 1.29;
        height: 32px;
        min-width: 80px;
        width: 50%;
    }

    .choice:first-child {
        color: #6c98ba;
        border: solid 2px #6c98ba;
        border-top-left-radius: 25px;
        border-bottom-left-radius: 25px;

        &:hover {
            background-color: lighten($color: #6c98ba, $amount: 30);
        }

        &.active {
            color: white;
            background-color: #6c98ba;
        }
    }

    .choice:last-child {
        color: #ff544a;
        border: solid 2px #ff544a;
        border-top-right-radius: 25px;
        border-bottom-right-radius: 25px;

        &:hover {
            background-color: lighten($color: #ff544a, $amount: 30);
        }

        &.active {
            color: white;
            background-color: #ff544a;
        }
    }
}
.no-data {
    margin-top: 10rem;
    font-size: 22px;
    font-weight: 500;
    color: #6c6c6c;
    text-align: center;
}
::v-deep .v-data-footer__icons-before {
    display: none;
}
::v-deep .v-data-footer__icons-after {
    display: none;
}
</style>
